import {
  ImageGallery,
  ImageGalleryImage,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useCallback } from 'react';
import { View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { filesSharedStyles } from './filesSharedStyles';

export const GalleryHeaderActions = () => {
  return null;
};

export const GalleryPanel = ({
  images,
  initialIndex,
  disableImageChange = false,
  onImageChange: onImageChangeProp,
}: {
  images: ImageGalleryImage[];
  initialIndex: number;
  disableImageChange?: boolean;
  onImageChange?: (index: number) => void;
}) => {
  const { setColumnTitle } = useSlideLayout();
  const navigate = useNavigate();
  const { assetId, issueId } = useParams();

  const handleImageChange = useCallback(
    (index: number) => {
      if (disableImageChange) {
        return;
      }

      const image = images[index];
      if (image?.name) {
        const name = image.name;
        setColumnTitle(name.length > 30 ? `${name.substring(0, 27)}...` : name);
      }

      if (onImageChangeProp) {
        onImageChangeProp(index);
        return;
      }

      if (image?.id && assetId) {
        const url = issueId 
          ? `/activities/${issueId}/asset/${assetId}/files/${image.id}` 
          : `/assets/${assetId}/files/${image.id}`;
        navigate(url, { replace: true });
      }
    },
    [images, setColumnTitle, disableImageChange, navigate, assetId, onImageChangeProp]
  );

  if (images.length === 0) return null;

  return (
    <View style={filesSharedStyles.galleryPanel}>
      <ImageGallery
        key={`${initialIndex}-${images[0]?.id}`}
        images={images}
        initialIndex={initialIndex}
        showThumbnails={images.length > 1}
        showHeader={false}
        disableImageChange={disableImageChange}
        onImageChange={handleImageChange}
      />
    </View>
  );
};
